if(typeof BSS_B2B != undefined) {
//handle cart page
  if(window.location.pathname === "/cart") {
      setTimeout(() =>{
        const targetProduct = document.querySelector(".shopify-section.recently-viewed__section");
        if (targetProduct) {
            BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false, false);
        }
      },1000)
  }
//handle quick view 
  if(!window.location.pathname.includes("/products")) {
      const mutationObserver = new MutationObserver((recordList, observe) => {
                 for (const record of recordList) {
                     if (record.target.classList.value === "product-form-holder--loaded" && record.addedNodes.length) {
                         BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false, true);
                     }
                 }
            });
      mutationObserver.observe(document, { childList: true, subtree: true });    
  }

  
  if(window.location.pathname.includes("/pages/registro-mayorista")) {
    setTimeout(() =>{
      $(".medium-up--push-one-twelfth h1").after("<p>¡Conviértete en mayorista y obtén un increíble 50% de descuento en toda nuestra joyería! Además, recibirás catálogos con precios al público para ofrecer a tus clientes, así como fotos y vídeos de nuestra joyería para que puedas impresionarlos con nuestras piezas. Regístrate ahora y descubre por qué somos la mejor opción para ti.</p>")
    }, 300)
  }

  //fix content DC header and button apply
   setTimeout(() => {
        let headerDiscountForm = document.querySelectorAll(".bss-b2b-translation-dc-form_header_text");
        let btnApply = document.querySelectorAll("#bss-b2b-discount-code-submit span");
        if (headerDiscountForm.length && btnApply.length) {
            headerDiscountForm.forEach((item) => {
                item.innerText = BSS_B2B.dcTranslations ? BSS_B2B.dcTranslations.form_header_text : "";
            });
            btnApply.forEach((item) => {
                item.innerText = BSS_B2B.dcTranslations ? BSS_B2B.dcTranslations.button_apply : "";
            });
        }
    }, 1500)
  
    BSS_B2B.currencyFormat['CRC'] = {
      money_format: "&#8353; {{ amount_no_decimals }}",
      money_with_currency_format: "&#8353; {{ amount_no_decimals }} CRC"
    }

  //fix spam checkout
  if(window.location.pathname.includes("/cart")) {
    setTimeout(() =>{
      function handleButtonClick(e) {
        e.preventDefault();
        const $button = $(this);
        let oldText = $(this).text();
        $button.css({'pointer-events': 'none', 'opacity': '0.6'});
        $button.text("Loading ...");
        setTimeout(() =>{
          $button.css({'pointer-events': 'unset', 'opacity': '1'})
            $button.text(oldText);
        }, 2000);
      }
     
     $(document).on('click dblclick', 'button[type="submit"]', handleButtonClick);
    }, 1000)
  }
  
}